import React from "react";
import { TransactionParent, Button } from "./transaction.styles";




const Transaction =()=>{

return(<TransactionParent>
       <h3>Transaction Summary</h3>
       

<Button>View all</Button>


</TransactionParent>



)




}


export default Transaction;
